/**
 * Error message constants for form validation
 * These messages provide user-friendly, field-specific prompts for required fields
 */
export const VALIDATION_ERROR_MESSAGES = {
    // Authentication fields
    email: 'Please enter an email address',
    'email address': 'Please enter an email address',
    password: 'Please enter your password',
    'current password': 'Please enter your current password',
    'new password': 'Please enter your new password',
    'confirm password': 'Please enter confirm password',
    // Personal information
    'first name': 'Please enter a first name',
    'last name': 'Please enter a last name',
    name: 'Please enter your name',
    title: 'Please select a title',
    // Contact information
    phone: 'Please enter a phone number',
    'phone number': 'Please enter a phone number',
    mobile: 'Please enter a mobile number',
    'mobile number': 'Please enter a mobile number',
    phone_trim: 'Please enter only numbers and spaces, it can start with + for international numbers',
    // Address fields
    address: 'Please enter an address',
    'address line 1': 'Please enter an address',
    'street address': 'Please enter street address',
    city: 'Please select a city',
    county: 'Please select a county',
    postcode: 'Please enter a postcode',
    'postal code': 'Please enter a postal code',
    'zip code': 'Please enter a zip code',
    country: 'Please select a country',
    state: 'Please select a state',
    // Date and time
    date: 'Please select a date',
    'delivery date': 'Please select a delivery date',
    // Messages and content
    message: 'Please enter a message',
    'card message': 'Please enter a card message',
    // Business information
    company: 'Please enter a company name',
    'company name': 'Please enter a company name',
    // Search and location
    search: 'Please enter a search term',
    location: 'Please enter a location',
    // Recipients and senders
    'recipient name': "Please enter the recipient's name",
    'sender name': "Please enter the sender's name",
    // Additional fields
    occasion: 'Please select an occasion',
    day: 'Please select a day',
    month: 'Please select a month',
    'billing address': 'Please enter a billing address',
    'collection address': 'Please enter a collection address',
    'recipient address': 'Please enter an address',
};
